/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Sale } from './Sale'
import {
  SaleFromJSON,
  SaleFromJSONTyped,
  SaleToJSON,
  SaleToJSONTyped,
} from './Sale'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'

/**
 *
 * @export
 * @interface ResponseSaleGetOne
 */
export interface ResponseSaleGetOne {
  /**
   *
   * @type {boolean}
   * @memberof ResponseSaleGetOne
   */
  success: boolean
  /**
   *
   * @type {Sale}
   * @memberof ResponseSaleGetOne
   */
  data?: Sale
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseSaleGetOne
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseSaleGetOne
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseSaleGetOne
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseSaleGetOne interface.
 */
export function instanceOfResponseSaleGetOne(
  value: object,
): value is ResponseSaleGetOne {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseSaleGetOneFromJSON(json: any): ResponseSaleGetOne {
  return ResponseSaleGetOneFromJSONTyped(json, false)
}

export function ResponseSaleGetOneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseSaleGetOne {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data: json['data'] == null ? undefined : SaleFromJSON(json['data']),
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseSaleGetOneToJSON(json: any): ResponseSaleGetOne {
  return ResponseSaleGetOneToJSONTyped(json, false)
}

export function ResponseSaleGetOneToJSONTyped(
  value?: ResponseSaleGetOne | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data: SaleToJSON(value['data']),
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
